import { gql } from 'graphql-request'

export const getUsuarioLogadoRolesQueryGql = gql`
  query GetUsuarioLogadoRolesQuery {
    usuarioLogado {
      id
      tipo {
        id
      }
      funcionalidades {
        id
        chave
      }
    }
  }
`
